// extracted by mini-css-extract-plugin
module.exports = {"new-indicator":"service-insight-heading_new-indicator__boR6X"};